import { useSearchParams } from 'react-router';
import type { TabItem } from './Tabs.js';

/** The tab named in the URL (`?tab=`), or the first when it names none of these. */
export function useTab<Id extends string>(
  tabs: readonly TabItem<Id>[],
  param = 'tab',
): [Id, (id: Id) => void] {
  const [params, setParams] = useSearchParams();
  const asked = params.get(param);
  const first = tabs[0]?.id;
  const current = tabs.find((tab) => tab.id === asked)?.id ?? first;
  if (current === undefined) throw new Error('useTab needs at least one tab');
  const select = (id: Id): void => {
    setParams(
      (previous) => {
        const next = new URLSearchParams(previous);
        if (id === first) next.delete(param);
        else next.set(param, id);
        return next;
      },
      { replace: true },
    );
  };
  return [current, select];
}
